import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectTranslationLookup } from "../Components/GetTranslationData/GetTranslationData ";

// `GetTranslationData` here is the memoized lookup from selectTranslationLookup,
// so the key list below stays identical while being resolved once per payload.
const buildTranslationData = (GetTranslationData) => ({
  pointsEarn: GetTranslationData("UIClient", "points_you_earn"),
  order_cancelled_by_customer_msg: GetTranslationData(
    "UIClient",
    "order_cancelled_by_customer_msg"
  ),
  pointsEarnedPayment: GetTranslationData(
    "UIClient",
    "points_earned_full_card_payment"
  ),
  pts: GetTranslationData("UIClient", "pts") || "Pts",
  pointsEarnedPurchase: GetTranslationData(
    "UIClient",
    "earn_points_with_purchase"
  ), // Earn Points with this Purchase
  promoCode: GetTranslationData("UIClient", "i_have_promo_code"), // I have promo code
  promoCodePlaceholder: GetTranslationData(
    "UIClient",
    "promo_code_placeholder"
  ), // Enter Promo Code
  apply: GetTranslationData("UIClient", "apply"),
  giftCard: GetTranslationData("UIClient", "gift_card"), // Gift Card
  discount: GetTranslationData("UIClient", "discount"), // Discount
  totalAmount: GetTranslationData("UIClient", "total_amount"), // Total Amount
  totalGiftCardValue: GetTranslationData("UIClient", "total_gift_card_value"),
  toPay: GetTranslationData("UIClient", "to_pay"),
  selectCard: GetTranslationData("UIClient", "select_card"), // SELECT CARD
  payWithPointsAndCard: GetTranslationData(
    "UIClient",
    "pay_with_points_and_card"
  ), // Pay with Points And Card
  totalAvailablePoints: GetTranslationData(
    "UIClient",
    "total_available_points"
  ), // Total Available Points
  userDetails: GetTranslationData("UIClient", "user_details"), // User Details
  nameLabel: GetTranslationData("UIClient", "name_label"), // Name
  mobileNo: GetTranslationData("UIClient", "mobile_number"), // Mobile No
  email: GetTranslationData("UIClient", "email"), // Email
  termsAndInstructions: GetTranslationData(
    "UIClient",
    "terms_and_instructions"), // T&C and Instructions
  buyNow: GetTranslationData("UIClient", "buy_now"), // Buy now //
  howToRedeem: GetTranslationData("UIClient", "how_to_redeem"), // How to Redeem?
  note: GetTranslationData("UIClient", "note"), // Note
  demoBomText: GetTranslationData("UIClient", "demo_bom_text"), // Demo BOM Text
  redeemableOnline: GetTranslationData("UIClient", "redeemable_online"), // Redeemable Online
  redeemableOffline: GetTranslationData("UIClient", "redeemable_offline"), // Redeemable Offline
  redeemableBoth: GetTranslationData("UIClient", "redeemable_both"), // Redeemable Both
  value: GetTranslationData("UIClient", "value"), // Value
  qty: GetTranslationData("UIClient", "qty"), // Qty

  showMore: GetTranslationData("UIClient", "show_more"), // Show More
  showLess: GetTranslationData("UIClient", "show_less"), // Show Less
  amazon: GetTranslationData("UIClient", "amazon"), // Amazon
  amazonGiftCard: GetTranslationData("UIClient", "amazon_gift_card"), // Amazon Gift Card
  rewardsEarned: GetTranslationData("UIClient", "rewards_earned"), // Rewards Earned
  saving: GetTranslationData("UIClient", "saving"), // Saving
  youPay: GetTranslationData("UIClient", "you_pay"), // You Pay
  upto15PercentDiscount: GetTranslationData(
    "UIClient",
    "upto_15_percent_discount"
  ), // Upto 15% Discount
  featuredGiftCards: GetTranslationData("UIClient", "featured_gift_cards"), // Featured Gift Cards
  howToUseGiftCard: GetTranslationData("UIClient", "how_to_use_gift_card"), // How to use your Gift Card?
  back: GetTranslationData("UIClient", "back"), // Back
  orderDetails: GetTranslationData("UIClient", "order_details"), // Order Details
  checkout: GetTranslationData("UIClient", "checkout"), // Checkout
  starting: GetTranslationData("UIClient", "starting"), // Starting
  continue: GetTranslationData("UIClient", "continue"), // Continue
  yourEGiftCards: GetTranslationData("UIClient", "your_e_gift_cards"), // Your E-Gift Cards
  orderNumber: GetTranslationData("UIClient", "order_number"), // Order Number
  copiedSuccessfully: GetTranslationData("UIClient", "copied_successfully"), // Copied successfully!
  eGiftCardCode: GetTranslationData("UIClient", "e_gift_card_code"), // E gift card code
  gcId: GetTranslationData("UIClient", "gc_id") || "GC ID", // GC ID
  expDate: GetTranslationData("UIClient", "exp_date"), // Exp Date
  visitNow: GetTranslationData("UIClient", "visit_now"), // Visit Now
  knowMore: GetTranslationData("UIClient", "know_more"), // Know More
  instructions: GetTranslationData("UIClient", "instructions"), // Instructions
  customerHelpDesk: GetTranslationData("UIClient", "customer_help_desk"), // Customer Help Desk
  NoRecordsFound: GetTranslationData("UIClient", "no_records_found"), // No records found
  termsAndConditions: GetTranslationData("UIClient", "terms_and_conditions"), // Terms and Conditions
  importantInstructions: GetTranslationData(
    "UIClient",
    "important_instructions"
  ), // Important Instructions

  orderConfirmation: GetTranslationData("UIClient", "order_confirmation"), // Order Confirmation
  orderAmount: GetTranslationData("UIClient", "order_amount"), // Order Amount
  bonusPoints: GetTranslationData("UIClient", "bonus_points"), // Bonus Points
  earned: GetTranslationData("UIClient", "earned"), // earned
  youEarned: GetTranslationData("UIClient", "you_earned"), // You Earned
  youHaveEarned: GetTranslationData("UIClient", "you_have_earned"), // You've Earned
  quantity: GetTranslationData("UIClient", "quantity"), // Quantity
  myOrderCardQuantity: GetTranslationData("UIClient", "myorder_card_quantity")?.trim(), // Card
  youPaid: GetTranslationData("UIClient", "you_paid"), // You Paid
  code: GetTranslationData("UIClient", "code"), // Code
  getCode: GetTranslationData("UIClient", "get_code"), // Get Code
  totalValue: GetTranslationData("UIClient", "total_value"), // Total Value
  totalPaid: GetTranslationData("UIClient", "total_paid"), // Total Paid

  enterOtpMessage: GetTranslationData("UIClient", "enter_4_digit_otp"), // Enter 4 digit OTP sent to
  resendOtp: GetTranslationData("UIClient", "resend_otp"), // Resend OTP
  submit: GetTranslationData("UIClient", "submit"), // Submit
  paymentFailed: GetTranslationData("UIClient", "payment_failed"), // Payment Failed
  yourPaymentFor: GetTranslationData("UIClient", "your_payment_for"), // Your Payment for
  couldNotBeProcessed: GetTranslationData("UIClient", "could_not_be_processed"), // could not be processed
  couldNotBeIssued: GetTranslationData("UIClient", "could_not_be_issued") || "could not be issued",

  contactSupport: GetTranslationData("UIClient", "contact_support"), // Contact Support
  retryPayment: GetTranslationData("UIClient", "retry_payment"), // Retry Payment
  // paymentNotProcessed: GetTranslationData(
  //     "UIClient",
  //     "payment_not_processed"
  // ), // Your Payment for could not be processed
  availableOnline: GetTranslationData("UIClient", "available_online"), // Available Online
  shopByBrands: GetTranslationData("UIClient", "shop_by_brands"), // Shop by Brands
  category: GetTranslationData("UIClient", "category"), // Category
  chooseYourDenomination: GetTranslationData(
    "UIClient",
    "choose_your_denomination"
  ), // Choose your Denomination
  luxuryChooseYourDenomination: GetTranslationData(
    "UIClient",
    "luxury_choose_your_denomination"
  ),
  points: GetTranslationData("UIClient", "points"), // Points
  clearFilter: GetTranslationData("UIClient", "clear_filter"), // Clear filter
  filterAndSort: GetTranslationData("UIClient", "filter_and_sort"), // Filter and Sort
  cancel: GetTranslationData("UIClient", "cancel"), // Cancel
  sortBy: GetTranslationData("UIClient", "sort_by"), // Sort by
  alphabet: GetTranslationData("UIClient", "alphabet"), // Alphabet
  clearSort: GetTranslationData("UIClient", "clear_sort"), // Clear Sort
  howCanWe: GetTranslationData("UIClient", "how_can_we"), // How can we
  helpYouToday: GetTranslationData("UIClient", "help_you_today"), //  help you today?
  contactNo: GetTranslationData("UIClient", "contact_no"), // Contact No
  contactMe: GetTranslationData("UIClient", "contact_me"), // Contact Me
  emailAddress: GetTranslationData("UIClient", "email_address"), // Email Address
  selectTheProduct: GetTranslationData("UIClient", "select_the_product"), // Select the product
  appleProduct: GetTranslationData("UIClient", "apple_product"), // Apple Product
  googlePlayStore: GetTranslationData("UIClient", "google_play_store"), // Google Play Store
  howCanWeHelpYou: GetTranslationData("UIClient", "how_can_we_help_you"), // How can we help you
  writeHere: GetTranslationData("UIClient", "write_here"), // Write here....
  attachAFile: GetTranslationData("UIClient", "attach_a_file"), // Attach a File
  reachUsAt: GetTranslationData("UIClient", "reach_us_at"), // Reach us at
  errorInImagePath: GetTranslationData("UIClient", "error_in_image_path"), // Error in image path
  off: GetTranslationData("UIClient", "off_label"), // OFF
  buyAndEarnUpTo: GetTranslationData("UIClient", "buy_and_earn_up_to"), // Buy & Earn up to
  startingFrom: GetTranslationData("UIClient", "starting_from"), // Starting from
  orRedeemFrom: GetTranslationData("UIClient", "or_redeem_from"), // or redeem from
  redeemFrom: GetTranslationData("UIClient", "redeem_from"), // Redeem from
  select: GetTranslationData("UIClient", "select"), // Select
  expired: GetTranslationData("UIClient", "expired"), // Expired

  addToCart: GetTranslationData("UIClient", "add_to_cart"), // Add to Cart

  orderPlaced: GetTranslationData("UIClient", "order_placed"), // Order Placed
  thankYou: GetTranslationData("UIClient", "thank_you"), // THANK YOU

  editUserDetails: GetTranslationData("UIClient", "edit_user_details"), // Edit User Details
  deliverTo: GetTranslationData("UIClient", "deliver_to"), // Deliver to
  yourOrderSummary: GetTranslationData("UIClient", "your_order_summary"), // Your order summary
  subTotal: GetTranslationData("UIClient", "sub_total"), // Sub Total
  redeemYour: GetTranslationData("UIClient", "redeem_your"), // Redeem Your
  height: GetTranslationData("UIClient", "height"), // Height
  centimetre: GetTranslationData("UIClient", "centimetre"), // Centimetre
  amountDue: GetTranslationData("UIClient", "amount_due"), // Amount Due
  paymentMethod: GetTranslationData("UIClient", "payment_method"), // Payment Method
  fullName: GetTranslationData("UIClient", "full_name"), // Full Name

  aboutGiftstacc: GetTranslationData("UIClient", "about_giftstacc"), // About Giftstacc
  termsConditions: GetTranslationData("UIClient", "terms_conditions"), // Terms & Conditions
  privacyPolicy: GetTranslationData("UIClient", "privacy_policy"), // Privacy Policy
  faq: GetTranslationData("UIClient", "faq"), // FAQ
  contactUs: GetTranslationData("UIClient", "contact_us"), // Contact us
  cancellationAndReturn: GetTranslationData(
    "UIClient",
    "cancellation_and_return"
  ), // Cancellation & Return
  aboutUs: GetTranslationData("UIClient", "about_us"), // About Us
  refundPolicy: GetTranslationData("UIClient", "refund_policy"), // Refund Policy
  refundInitiated: GetTranslationData("UIClient", "refund_initiated") || "Refund Initiated",
  refundDue: GetTranslationData("UIClient", "refund_due"),
  refundInitiatedMessage: GetTranslationData(
    "UIClient",
    "refund_initiated_message"
  ) || "refund initiated. Usually arrives in 3-5 working days.",
  firstName: GetTranslationData("UIClient", "first_name"), // First Name
  lastName: GetTranslationData("UIClient", "last_name"), // Last Name
  emailId: GetTranslationData("UIClient", "email_id"), // Email id

  myWishlist: GetTranslationData("UIClient", "my_wishlist"), // My Wishlist
  amazonShoppingVoucher: GetTranslationData(
    "UIClient",
    "amazon_shopping_voucher"
  ), // Amazon Shopping Voucher
  eGiftCard: GetTranslationData("UIClient", "e_gift_card") || "e-Gift Card", // E-Gift Card
  price: GetTranslationData("UIClient", "price"), // Price
  moveToCart: GetTranslationData("UIClient", "move_to_cart"), // Move to Cart
  errorName: GetTranslationData("UIClient", "permission_denied"), // Permission Denied
  errorDescription: GetTranslationData("UIClient", "not_able_to_access_url"), // You are not able to access this url
  backToHome: GetTranslationData("UIClient", "back_to_home")?.trim() || "Back to Home", // Back to Home
  more: GetTranslationData("UIClient", "more"), // More
  eGiftCards: GetTranslationData("UIClient", "e_gift_cards"), // e-Gift Cards
  shopByCategory: GetTranslationData("UIClient", "shop_by_category"), // Shop by category
  orders: GetTranslationData("UIClient", "orders"), // Orders
  orderDate: GetTranslationData("UIClient", "order_date"), // Order Date
  amazonPay: GetTranslationData("UIClient", "amazon_pay"), // Amazon Pay
  yourOrders: GetTranslationData("UIClient", "your_orders"), // Your Orders
  exploreGiftCards: GetTranslationData("UIClient", "explore_gift_cards"), // Explore Gift Cards
  myAccount: GetTranslationData("UIClient", "my_account"), // My Account
  myOrders: GetTranslationData("UIClient", "my_orders"), // My Orders
  discountFlat: GetTranslationData("UIClient", "discount_flat"), // Discount Flat
  orderSummary: GetTranslationData("UIClient", "order_summary"), // Order Summary
  total: GetTranslationData("UIClient", "total"), // Total
  pointsUsed: GetTranslationData("UIClient", "points_used"), // Points Used
  phoneSkype: GetTranslationData("UIClient", "phone_skype"), // Phone/Skype
  aboutYourProject: GetTranslationData("UIClient", "about_your_project"), // About Your Project
  hi: GetTranslationData("UIClient", "hi_label"), // Hi
  searchGiftCard: GetTranslationData("UIClient", "search_gift_card"), // Search any Gift card
  earn: GetTranslationData("UIClient", "earn"), // Earn
  footerCopyright: GetTranslationData("UIClient", "footer_copyright"), // 2025 Giftstacc All rights reserved. Powered by Customer Capital
  applicationUrlIsNotRegistered: GetTranslationData(
    "UIClient",
    "application_url_is_not_registerd"
  ),
  internalServerError: GetTranslationData("UIClient", "internal_server_error")?.trim() || "Internal Server Error",
  permissionToViewThisResource: GetTranslationData(
    "UIClient",
    "permission_to_view_this_resource"
  )?.trim() || "You do not have permission to view this resource",
  continueShopping: GetTranslationData("UIClient", "continue_shopping"),
  goToMyOrder: GetTranslationData("UIClient", "go_to_my_order"),
  canNotAddMoreThan10: GetTranslationData(
    "UIClient",
    "can_not_add_more_than_10"
  ),
  pleaseAddSomeProductsQuantitys: GetTranslationData(
    "UIClient",
    "please_add_some_products_quantitys"
  ),
  instantVouchers: GetTranslationData("UIClient", "instant_vouchers"),
  giftCardPurchaseSuccess: GetTranslationData(
    "UIClient",
    "e_gift_card_purchase_success"
  ),
  vouchersPurchased: GetTranslationData("UIClient", "vouchers_purchased"),
  voucher: GetTranslationData("UIClient", "voucher"),
  vouchers: GetTranslationData("UIClient", "vouchers"),
  voucherFailed:
    GetTranslationData("UIClient", "voucher_failed") || "Voucher Failed",
  vouchersFailed:
    GetTranslationData("UIClient", "vouchers_failed") || "Vouchers Failed",
  voucherLabel: GetTranslationData("UIClient", "voucher_label"),
  vouchersLabel: GetTranslationData("UIClient", "vouchers_label"),
  voucherPurchasedSuccessfully: GetTranslationData(
    "UIClient",
    "voucher_purchased_successfully"
  ) || "voucher purchased successfully",
  vouchersPurchasedSuccessfully: GetTranslationData(
    "UIClient",
    "vouchers_purchased_successfully"
  ) || "vouchers purchased successfully",
  voucherId: GetTranslationData("UIClient", "voucher_id") || "Voucher ID",
  amount: GetTranslationData("UIClient", "amount") || "Amount",
  voucherCode: GetTranslationData("UIClient", "voucher_code") || "Voucher Code",
  pin: GetTranslationData("UIClient", "pin") || "PIN",
  expires: GetTranslationData("UIClient", "expires") || "Expires",
  instructions_and_how_to_use: GetTranslationData("UIClient", "instructions_and_how_to_use"),
  issuedVouchers: GetTranslationData("UIClient", "issued_vouchers") || "Issued vouchers",
  loadingVoucherDetails: GetTranslationData(
    "UIClient",
    "loading_voucher_details"
  ) || "Loading voucher details...",
  voucherDetailsUnavailable: GetTranslationData(
    "UIClient",
    "voucher_details_unavailable"
  ) || "Voucher details are not available right now.",
  copyVoucherCode: GetTranslationData("UIClient", "copy_voucher_code") || "Copy voucher code",
  copyPin: GetTranslationData("UIClient", "copy_pin") || "Copy PIN",
  copied: GetTranslationData("UIClient", "copied") || "Copied",
  noFee: GetTranslationData("UIClient", "no_fee"),
  keepShoppingEarnMore: GetTranslationData(
    "UIClient",
    "keep_shopping_earn_more"
  ) || "Keep shopping to earn more!",
  keepShoppingSaveMore: GetTranslationData(
    "UIClient",
    "keep_shopping_save_more"
  ),
  errorInSendingOTP: GetTranslationData("UIClient", "error_in_sending_OTP"),
  backToHomepage: GetTranslationData("UIClient", "back_to_homepage"),
  redeemPointsCheckout: GetTranslationData(
    "UIClient",
    "redeem_points_checkout"
  ),
  checkoutRedeemPoints: GetTranslationData("UIClient", "luxury_redeem_points"),
  checkoutEarnPoints: GetTranslationData("UIClient", "luxury_earn_points"),
  checkoutEarnRedeemHint: GetTranslationData("UIClient", "luxury_earn_redeem_hint"),
  checkoutYouSave: GetTranslationData("UIClient", "luxury_you_save"),
  checkoutMinimum: GetTranslationData("UIClient", "luxury_minimum"),
  checkoutMaximum: GetTranslationData("UIClient", "luxury_maximum"),
  checkoutWillEarn: GetTranslationData("UIClient", "luxury_will_earn"),
  checkoutWorth: GetTranslationData("UIClient", "luxury_worth"),
  checkoutInsufficientBalance: GetTranslationData("UIClient", "luxury_insufficient_balance"),
  checkoutEarnUnsupported: GetTranslationData("UIClient", "luxury_earn_unsupported"),
  checkoutRedeemUnsupported: GetTranslationData("UIClient", "luxury_card_redemption_unsupported"),
  checkoutEarnRedeemUnsupported: GetTranslationData("UIClient", "luxury_redeem_unsupported"),
  checkoutOrderEarnRedeemUnavailable: GetTranslationData("UIClient", "luxury_order_earn_redeem_unavailable"),
  checkoutMinimumRewardNotMet: GetTranslationData("UIClient", "minimum_reward_not_met"),
  checkoutEstimatedReward: GetTranslationData("UIClient", "estimated_reward_amount"),
  checkoutMinimumRewardOrder: GetTranslationData("UIClient", "minimum_reward_order_message"),
  pleaseAddTheProduct: GetTranslationData("UIClient", "please_add_the_product"),
  only10ProductsCanBeAllowed: GetTranslationData(
    "UIClient",
    "only_10_products_can_be_allowed"
  ),
  rupee_Symbol: GetTranslationData("UIClient", "rupee_Symbol") || "₹",
  products: GetTranslationData("UIClient", "products"),
  showing: GetTranslationData("UIClient", "showing"),
  items: GetTranslationData("UIClient", "items"),
  results: GetTranslationData("UIClient", "results"),
  trendingOnly: GetTranslationData("UIClient", "trendingOnly"),
  toggle: GetTranslationData("UIAdmin", "toggle"),
  detailsSentRegistered: GetTranslationData(
    "UIClient",
    "details_sent_registered"
  ),
  mobileEmail: GetTranslationData("UIClient", "mobile_email"),
  detailsSentRegisteredContact: GetTranslationData(
    "UIClient",
    "details_sent_registered_contact"
  ),
  emailSentSuccessfully: GetTranslationData(
    "UIClient",
    "email_sent_successfully"
  ),
  retrieveCode: GetTranslationData("UIClient", "retrieve_code"),
  resendCode: GetTranslationData("UIClient", "resend_code"),
  earnUpto: GetTranslationData("UIClient", "earn_upto"),
  loginLabel: GetTranslationData("UIAdmin", "login_label"),
  myProfile: GetTranslationData("UIAdmin", "my_Profile"),
  searchForGiftcard: GetTranslationData("UIAdmin", "search_for_giftcard"),
  filters: GetTranslationData("UIAdmin", "filters"),
  order_failed_orderdetails: GetTranslationData(
    "UIClient",
    "order_failed_orderdetails"
  ),
  vendor_order_failed_orderdetails: GetTranslationData(
    "UIClient",
    "vendor_order_failed_orderdetails"
  ),
  offLabel: GetTranslationData("UIClient", "off_label"), // Off
  offLower: GetTranslationData("UIClient", "off_lower"), // off
  routeNotFound: GetTranslationData("UIClient", "route_not_found"), // Route not found
  pageNotFoundMessage: GetTranslationData("UIClient", "page_not_found_message"), // The page you were looking for is not found!
  congratsYouHaveOrdered: GetTranslationData(
    "UIClient",
    "congrates_you_have_ordered"
  ), // Congrats! You’ve ordered
  worth: GetTranslationData("UIClient", "worth_₹"), // worth ₹
  bankOfMaharashtra: GetTranslationData("UIClient", "bank_of_maharashtra"), // Bank of Maharashtra
  from: GetTranslationData("UIClient", "from"), // from
  giftstaccAccess: GetTranslationData("UIClient", "giftstacc_access_message"), // Giftstacc! Access here
  tnc: GetTranslationData("UIClient", "tnc"), // T%26C:
  custcap: GetTranslationData("UIClient", "custcap"), // CustCap
  sec: GetTranslationData("UIClient", "sec"), // Sec
  in: GetTranslationData("UIClient", "in"), // in
  youCannotPurchaseMoreThan: GetTranslationData(
    "UIClient",
    "you_cannot_purchase_more_than"
  ),
  giftGardsInTotal: GetTranslationData("UIClient", "gift_cards_in_total"),
  giftCardsForSupplierQuickSilver: GetTranslationData(
    "UIClient",
    "gift_cards_for_supplier_QuickSilver"
  ),
  orderCancelled: GetTranslationData("UIClient", "order_cancelled"),
  orderDetailsMessage: GetTranslationData("UIClient", "order_details_message"),
  discount_flat: GetTranslationData("UIClient", "discount_flat"),
  max_capping_allowed: GetTranslationData("UIClient", "max_capping_allowed"),
  max_limit_allowed: GetTranslationData("UIClient", "max_limit_allowed"),
  with: GetTranslationData("UIClient", "with"),
  order_failure: GetTranslationData("UIClient", "order_failure"),
  e_gift_card_purchase: GetTranslationData("UIClient", "e_gift_card_purchase"),
  redeem_text: GetTranslationData("UIClient", "redeem_text"),
  order_failed: GetTranslationData("UIClient", "order_failed"),
  gift_card_purchase: GetTranslationData("UIClient", "gift_card_purchase"),
  gift_voucher_purchase_failed:
    GetTranslationData("UIClient", "gift_voucher_purchase_failed") || "Gift voucher purchase could not be completed",
  your_order_text: GetTranslationData("UIClient", "your_order_text"),
  order_proccessing_message: GetTranslationData("UIClient", "order_proccessing_message"),
  hang_tight: GetTranslationData("UIClient", "hang_tight"),
  continue_shopping: GetTranslationData("UIClient", "continue_shopping"),
  plus_gst: GetTranslationData("UIClient", "plus_gst"),
  convenience_fe: GetTranslationData("UIClient", "convenience_fe"),
  terms_condition: GetTranslationData("UIClient", "terms&condition"),
  how_to_use: GetTranslationData("UIClient", "how_to_use"),
  outof: GetTranslationData("UIClient", "out_of"),

  calculate_reward_points_on: GetTranslationData("UIClient", "calculate_reward_points_on"),
  american_express: GetTranslationData("UIClient", "american_express"),
  you_will_earn_lower: GetTranslationData("UIClient", "you_will_earn_lower"),
  reward_points: GetTranslationData("UIClient", "reward_points"),
  you_will_earn_label: GetTranslationData("UIClient", "you_will_earn_label"),
  purchase_limit_alert: GetTranslationData("UIClient", "purchase_limit_alert"),
  next_month: GetTranslationData("UIClient", "next_month"),
  next_week: GetTranslationData("UIClient", "next_week"),
  next_day: GetTranslationData("UIClient", "next_day"),
  processing_payment_heade_msg: GetTranslationData("UIClient", "processing_payment_heade_msg"),
  processing_payment_description_msg_1: GetTranslationData("UIClient", "processing_payment_description_msg_1"),
  processing_payment_description_msg_2: GetTranslationData("UIClient", "processing_payment_description_msg_2"),
  view_orders: GetTranslationData("UIClient", "view_orders"),
  payment_processing_color_label: GetTranslationData("UIClient", "payment_processing_color_label"),
  widget_popup_title: GetTranslationData("UIClient", "widget_popup_title"),
  widget_earn_txt: GetTranslationData("UIClient", "widget_earn_txt"),
  widget_reward_points_limit_txt: GetTranslationData("UIClient", "widget_reward_points_limit_txt"),
  session_expire_heading: GetTranslationData("UIClient", "session_expire_heading"),
  session_expire_msg: GetTranslationData("UIClient", "session_expire_msg"),
  rem_limit_heading: GetTranslationData("UIClient", "rem_limit_heading"),
  searchbybrand: GetTranslationData("UIClient", "searchbybrand"),
  ReachUsAT: GetTranslationData("UIClient", "ReachUsAT"),
  contactus_number: GetTranslationData("UIClient", "contactus_number"),
  contact_available: GetTranslationData("UIClient", "contact_available"),
  This_brand_available_with_the_current_filters: GetTranslationData("UIClient", "This_brand_available_with_the_current_filters"),
  points_credited_successful_transaction: GetTranslationData("UIClient", "points_credited_successful_transaction"),
  keepTyping: GetTranslationData("UIClient", "keepTyping"),
  CompleteFirstOrder: GetTranslationData("UIClient", "complete_first_order"),
  UnableToResendTheCode: GetTranslationData("UIClient", "unable_to_resend_the_code"),
  VoucherSuccessMessage: GetTranslationData("UIClient", "voucher_success_message"),
  email_required: GetTranslationData("UIClient", "email_required"),
  firstName_required: GetTranslationData("UIClient", "firstName_required"),
  lastName_required: GetTranslationData("UIClient", "lastName_required"),
  mobile_number_required: GetTranslationData("UIClient", "mobile_number_required"),
  email_validation_message: GetTranslationData("UIClient", "email_validation_message"),
  ReLoginAtCheckoutPage: GetTranslationData("UIClient", "re_login_msg_at_checkout_page"),

  redirecting_text: GetTranslationData("UIClient", "redirecting_text"),
  confirm_process: GetTranslationData("UIClient", "confirm_process"),
  confirm_text: GetTranslationData("UIClient", "confirm_text"),
  luxury_confirm_text: GetTranslationData("UIClient", "luxury_confirm_text"),
  stock_out: GetTranslationData("UIClient", "stock_out"),
  out_of_stock: GetTranslationData("UIClient", "out_of_stock"),
  out_of: GetTranslationData("UIClient", "out_of"),
  stockout_message_title: GetTranslationData("UIClient", "stockout_message_title"),
  stockout_message_desc: GetTranslationData("UIClient", "stockout_message_desc"),
  AvailabilityOfDenominations: GetTranslationData("UIClient", "AvailabilityOfDenominations"),
  pay_with_membership_rewards_at_safekey_checkout: GetTranslationData("UIClient", "pay_with_membership_rewards_at_safekey_checkout"),
  stockout_message_desc_all_denomination: GetTranslationData("UIClient", "stockout_message_desc_all_denomination"),
  Selected_denomination_currently_out_stock: GetTranslationData("UIClient", "Selected_denomination_currently_out_stock"),
  Voucher_code_resent_registered_email_and_mobile_number: GetTranslationData("UIClient", "Voucher_code_resent_registered_email_and_mobile_number"),
  Voucher_code_resent_registered_email: GetTranslationData("UIClient", "Voucher_code_resent_registered_email"),
  Voucher_code_resent_registered_mobile: GetTranslationData("UIClient", "Voucher_code_resent_registered_mobile"),
  redemption_fee_text: GetTranslationData("UIClient", "redemption_fee_text"),
  know_more_text: GetTranslationData("UIClient", "know_more_text"),
  redemption_fee_content: GetTranslationData("UIClient", "redemption_fee_content"),
  transaction_limit_exceed: GetTranslationData("UIClient", "transaction_limit_exceed")?.trim() || "Maximum transaction amount limit exceeded.",
  contactFormTokenSuccessMessage: GetTranslationData("UIClient", "contactFormTokenSuccessMessage"),
  contactFormTokenErrorMessage: GetTranslationData("UIClient", "contactFormTokenErrorMessage"),
  // Validation error messages for points redemption
  invalidPointsValue: GetTranslationData("UIClient", "invalid_points_value") || "Please enter a valid points value.",
  negativePointsError: GetTranslationData("UIClient", "negative_points_error") || "Points cannot be negative.",
  maxPointsError: GetTranslationData("UIClient", "max_points_error") || "Maximum redeemable points is",
  enterPoints: GetTranslationData("UIClient", "enter_points") || "Enter points",
  // Min/Max redemption messages - using template format
  min_max_redeem_percentage_minimum: GetTranslationData("UIClient", "min_redeem_percentage") || "You must redeem at least",
  min_max_redeem_percentage_maximum: GetTranslationData("UIClient", "max_redeem_percentage") || "You can redeem up to",
  min_max_redeem_points_minimum: GetTranslationData("UIClient", "min_redeem_points") || "Minimum redemption for this card is",
  min_max_redeem_points_maximum: GetTranslationData("UIClient", "max_redeem_points") || "Maximum redemption for this card is",
  redeem_transaction_value_points: GetTranslationData("UIClient", "redeem_transaction_value_points") || "of the transaction value using reward points.",
  redeem_points_label: GetTranslationData("UIClient", "redeem_points_label") || "points.",
  payment_failed_purchase: GetTranslationData("UIClient", "payment_failed_purchase"),
  discountOffLabel: GetTranslationData("UIClient", "discount_off_label") || "Off",
  flatDiscount: GetTranslationData("UIClient", "flat_discount") || "Discount Flat",
  failedContactSupport: GetTranslationData("UIClient", "failed_contact_support"),
  // Order details (thank-you) page labels, kept separate from cart/checkout keys
  thankYouVoucherDelivered: GetTranslationData("UIClient", "thank_you_voucher_delivered") || "Voucher Delivered",
  thankYouVouchersDelivered: GetTranslationData("UIClient", "thank_you_vouchers_delivered") || "Vouchers Delivered",
  thankYouKeepShopping: GetTranslationData("UIClient", "thank_you_keep_shopping"),
  thankYouGiftVoucher: GetTranslationData("UIClient", "thank_you_gift_voucher") || "Gift Voucher",
  thankYouGiftVouchers: GetTranslationData("UIClient", "thank_you_gift_vouchers") || "Gift Voucher(s)",
  thankYouTotalDiscount: GetTranslationData("UIClient", "thank_you_total_discount") || "Total Discount",
  thankYouOrderSummary: GetTranslationData("UIClient", "thank_you_order_summary") || "Order Summary",
  thankYouConvenienceFee: GetTranslationData("UIClient", "thank_you_convenience_fee") || "Convenience Fee",
  thankYouPlusGst: GetTranslationData("UIClient", "thank_you_plus_gst") || "+ GST",
  thankYouTotalAmount: GetTranslationData("UIClient", "thank_you_total_amount") || "Total Amount",
  thankYouOrderNumber: GetTranslationData("UIClient", "thank_you_order_number") || "Order Number",
  thankYouOrderAmount: GetTranslationData("UIClient", "thank_you_order_amount") || "Order Amount",
  thankYouTitle: GetTranslationData("UIClient", "thank_you_title") || "Thank You",
  thankYouOrderFailed: GetTranslationData("UIClient", "thank_you_order_failed") || "Order Failed",
  thankYouContactSupport: GetTranslationData("UIClient", "thank_you_contact_support") || "Contact support",
  thankYouDetailsSent: GetTranslationData("UIClient", "thank_you_details_sent") || "Order details have been sent to your registered mobile number and email.",
  thankYouRefundInitiated: GetTranslationData("UIClient", "thank_you_refund_initiated") || "Refund Initiated",
  thankYouOrderCancelledNote: GetTranslationData("UIClient", "thank_you_order_cancelled_note") || "Your order is being cancelled by us. The amount paid by you will be credited back to the source. Usually arrives in 3-5 working days.",
  close: GetTranslationData("UIClient", "close"),
  earnBonusRewardPoints: GetTranslationData("UIClient", "earn_bonus_reward_points"),
  earn_bonus_reward_productList: GetTranslationData("UIClient", "earn_bonus_reward_productList"),
  validFor: GetTranslationData("UIClient", "valid_for") || "Valid for",
  usage: GetTranslationData("UIClient", "usage") || "Usage",
  usageOnline: GetTranslationData("UIClient", "usage_online") || "Online",
  usageOffline: GetTranslationData("UIClient", "usage_offline") || "In-store",
  usageBoth: GetTranslationData("UIClient", "usage_both") || "Online & in-store",
  month: GetTranslationData("UIClient", "month") || "Month",
  months: GetTranslationData("UIClient", "months") || "Months",
  upgradedPlatformMessage: GetTranslationData("UIClient", "upgraded_platform_message") || "We've upgraded our gift cards platform. View your older orders on the previous platform.",
  upgradedPlatformTitle: GetTranslationData("UIClient", "upgraded_platform_title") || "Not able to find your order?",
  viewOlderOrders: GetTranslationData("UIClient", "view_older_orders") || "View older orders",
  viewAll: GetTranslationData("UIClient", "viewAll") || "View All",
  orderSummaryTitle: GetTranslationData("UIClient", "order_summary_title") || "Order summary",
  purchasedOn: GetTranslationData("UIClient", "purchased_on") || "Purchased on",
  cashAmount: GetTranslationData("UIClient", "cash_amount") || "Cash amount",
  pointsRedeemed: GetTranslationData("UIClient", "points_redeemed") || "Points redeemed",
  cardsLabel: GetTranslationData("UIClient", "cards_label") || "Cards",
  orderSummaryQuantity: GetTranslationData("UIClient", "order_summary_quantity") || "Quantity",
  cardHeaderTotalPoints: GetTranslationData("UIClient", "card_header_total_points") || "Total Points",
  cardHeaderViewPoints: GetTranslationData("UIClient", "card_header_view_points") || "View Points",
  cardHeaderReserveNote: GetTranslationData("UIClient", "card_header_reserve_note") || "Only select cards with exclusive access to Reserve appear here.",
  cartTitle: GetTranslationData("UIClient", "cart_title") || "Cart",
  cartItemInCart: GetTranslationData("UIClient", "cart_item_in_cart") || "item in cart",
  cartItemsInCart: GetTranslationData("UIClient", "cart_items_in_cart") || "items in cart",
  cartEmptyTitle: GetTranslationData("UIClient", "cart_empty_title") || "Your cart is empty",
  cartEmptyMessage: GetTranslationData("UIClient", "cart_empty_message") || "Gift cards from 300+ brands are waiting. Add a few denominations and check out in one go.",
  cartBrowseGiftCards: GetTranslationData("UIClient", "cart_browse_gift_cards") || "Browse gift cards",
  cartGiftVoucher: GetTranslationData("UIClient", "cart_gift_voucher") || "Gift Voucher",
  cartGiftVouchers: GetTranslationData("UIClient", "cart_gift_vouchers") || "Gift Voucher(s)",
  cartConvenienceFee: GetTranslationData("UIClient", "cart_convenience_fee") || GetTranslationData("UIClient", "convenience_fe") || "Convenience Fee",
  cartPlusGst: GetTranslationData("UIClient", "cart_plus_gst") || GetTranslationData("UIClient", "plus_gst") || "+ GST",
  cartTotalDiscount: GetTranslationData("UIClient", "cart_total_discount") || "Total Discount",
  cartSaved: GetTranslationData("UIClient", "cart_saved") || "Saved",
  cartUnavailable: GetTranslationData("UIClient", "cart_unavailable") || "Unavailable",
  cartRemoveItem: GetTranslationData("UIClient", "cart_remove_item") || "Remove item",
  cartPurchaseLimit: GetTranslationData("UIClient", "cart_purchase_limit") || "purchases are limited to",
  cartLimitPrefix: GetTranslationData("UIClient", "cart_limit_prefix") || "You can buy up to",
  cartLimitSuffix: GetTranslationData("UIClient", "cart_limit_suffix") || "in Gift Vouchers at a time. Adjust your cart to continue.",
  cartLoadError: GetTranslationData("UIClient", "cart_load_error") || "We couldn't load your cart. Please try again.",
  cartUpdateError: GetTranslationData("UIClient", "cart_update_error") || "We couldn't update your cart. Please try again.",
  cartExcludedOutOfStockOne: GetTranslationData("UIClient", "cart_excluded_out_of_stock_one") || "{count} item is out of stock",
  cartExcludedOutOfStockMany: GetTranslationData("UIClient", "cart_excluded_out_of_stock_many") || "{count} items are out of stock",
  cartExcludedUnavailableOne: GetTranslationData("UIClient", "cart_excluded_unavailable_one") || "{count} item is unavailable",
  cartExcludedUnavailableMany: GetTranslationData("UIClient", "cart_excluded_unavailable_many") || "{count} items are unavailable",
  cartExcludedMixed: GetTranslationData("UIClient", "cart_excluded_mixed") || "{count} items can't be ordered",
  cartExcludedMessageOne: GetTranslationData("UIClient", "cart_excluded_message_one") || "This item will be removed from your cart and won't be included in this order.",
  cartExcludedMessageMany: GetTranslationData("UIClient", "cart_excluded_message_many") || "These items will be removed from your cart and won't be included in this order.",
  cartAmountPayable: GetTranslationData("UIClient", "cart_amount_payable") || "Amount payable",
  cartContinueToCheckout: GetTranslationData("UIClient", "cart_continue_to_checkout") || "Continue to Checkout",
  cartCheckoutOneBrand: GetTranslationData("UIClient", "cart_checkout_one_brand") || "You can check out one brand at a time for now. Remove the other brands to continue.",
  cartClose: GetTranslationData("UIClient", "cart_close") || "Close",
  cartItemOutOfStockMessage: GetTranslationData("UIClient", "cart_item_out_of_stock_message") || "This gift voucher is out of stock.",
  cartItemUnavailableMessage: GetTranslationData("UIClient", "cart_item_unavailable_message") || "This gift voucher is unavailable.",
  cartRemove: GetTranslationData("UIClient", "cart_remove") || "Remove",
  cartHeaderLabel: GetTranslationData("UIClient", "cart_header_label") || "Cart",
});

const useTranslationData = () => {
  const lookup = useSelector(selectTranslationLookup);
  return useMemo(() => buildTranslationData(lookup), [lookup]);
};

// Kept under the existing name so all call sites stay unchanged.
const getTranslationData = useTranslationData;
export default getTranslationData;
